/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoTwoFactorAutheticationInput = {
    clientMutationId?: string | null;
    otp: string;
    otpRequiredForLogin: boolean;
};
export type BarcodeTwoFactorAuthMutationVariables = {
    input: infoTwoFactorAutheticationInput;
};
export type BarcodeTwoFactorAuthMutationResponse = {
    readonly infoTwoFactorAuthetication: {
        readonly clientMutationId: string | null;
    } | null;
};
export type BarcodeTwoFactorAuthMutation = {
    readonly response: BarcodeTwoFactorAuthMutationResponse;
    readonly variables: BarcodeTwoFactorAuthMutationVariables;
};



/*
mutation BarcodeTwoFactorAuthMutation(
  $input: infoTwoFactorAutheticationInput!
) {
  infoTwoFactorAuthetication(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoTwoFactorAutheticationPayload",
    "kind": "LinkedField",
    "name": "infoTwoFactorAuthetication",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BarcodeTwoFactorAuthMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BarcodeTwoFactorAuthMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8502586ad5f06c5440744b63498490ea",
    "id": null,
    "metadata": {},
    "name": "BarcodeTwoFactorAuthMutation",
    "operationKind": "mutation",
    "text": "mutation BarcodeTwoFactorAuthMutation(\n  $input: infoTwoFactorAutheticationInput!\n) {\n  infoTwoFactorAuthetication(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd4488003ea412188ea805d4a0c156fa2';
export default node;
